import mixpanel from 'mixpanel-browser';

import { analyticsEvents, type AnalyticsEvent } from './events';

const buildEventPayload = (event: AnalyticsEvent, attrs: Record<string, any>) => {
  const props = event.extra ? event.extra(attrs) : {}
  return { name: event.name, props }
}

export const trackAnalyticsEvent = (eventKey: keyof typeof analyticsEvents, attrs?: Record<string, any>) => {
  const event = analyticsEvents[eventKey]

  if (!event) {
    console.warn(`Unknown analytics event: ${eventKey}`)
    return
  }

  try {
    const { name, props } = buildEventPayload(event, attrs)
    mixpanel.track(name, props)
  } catch (error) {
    console.error('Analytics tracking error:', error)
  }
}
